(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-bottle-dock"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tagName = 'rr-scroll-bottle-dock-v6';
  if (customElements.get(tagName)) return;
  let copySequence = 0;
  const mod = (value, span) => ((value % span) + span) % span;
  const loadGSAP = () => {
    if (window.gsap) return Promise.resolve(window.gsap);
    if (window.rrBottleDockGSAP) return window.rrBottleDockGSAP;
    window.rrBottleDockGSAP = new Promise(resolve => {
      const script = document.createElement('script');
      let finished = false;
      const finish = () => { if (!finished) { finished = true; clearTimeout(timeout); resolve(window.gsap || null); } };
      const timeout = setTimeout(finish, 8000);
      script.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js';
      script.async = true; script.onload = finish; script.onerror = finish;
      document.head.append(script);
    });
    return window.rrBottleDockGSAP;
  };
  class RRBottleDock extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.rr-dock__track');
      this.originals = Array.from(this.querySelectorAll('.rr-dock__card:not([data-loop-copy])'));
      if (!this.originals.length) return;
      this.originals.forEach(card => {
        const gallery = card.querySelector('[ref="cardGallery"],.card-gallery,.product-card-gallery');
        const template = card.querySelector('template[data-cutout]');
        if (gallery && template && !gallery.querySelector('.rr-native-cutout')) {
          gallery.prepend(template.content.cloneNode(true)); gallery.classList.add('rr-custom-gallery');
        }
        card.querySelector('.product-card__link')?.setAttribute('data-product-link', '');
        const controls = card.querySelector('[data-size-controls]');
        if (gallery && controls && gallery.parentElement === card.querySelector('.product-card__content')) {
          gallery.after(controls);
        }
        this.applySize(card, card.dataset.selectedSize);
      });
      this.viewport = this.querySelector('[data-viewport]');
      this.previous = this.querySelector('[data-prev]'); this.next = this.querySelector('[data-next]');
      this.controller = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.carousel = this.dataset.layout === 'carousel';
      this.loop = this.carousel && this.originals.length > 1;
      this.selected = Math.min(this.originals.length - 1, Math.max(0, Number(this.dataset.initial) || 0));
      this.finiteSelection = this.loop ? null : this.selected;
      this.lift = this.carousel ? Number(this.dataset.lift) || 0 : 0;
      this.scale = this.carousel ? Number(this.dataset.scale) || 1.2 : 1;
      this.radius = Number(this.dataset.radius) || 2.5;
      this.speed = Number(this.dataset.speed) || 1;
      this.scrollState = { value: 0 }; this.scrollTarget = 0;
      this.programmaticFocus = false;
      this.setAttribute('data-ready', '');
      const on = (target, type, fn, options = {}) => target?.addEventListener(type, fn, { ...options, signal: this.controller.signal });
      on(this.viewport, 'wheel', event => {
        if (!this.carousel || (!this.loop && this.viewport.scrollWidth <= this.viewport.clientWidth) || event.ctrlKey || event.target.closest('input,select,textarea')) return;
        // Only a predominantly horizontal wheel/trackpad gesture belongs to the dock.
        // Leave vertical and diagonal vertical gestures to normal page navigation.
        if (!event.deltaX || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        if (event.cancelable) event.preventDefault();
        const unit = event.deltaMode === 1 ? 18 : event.deltaMode === 2 ? this.viewport.clientWidth : 1;
        const delta = event.deltaX;
        this.finiteSelection = null;
        this.scrollTo(this.scrollTarget + delta * unit * this.speed);
      }, { passive: false });
      on(this.viewport, 'scroll', () => {
        if (!this.carousel || !this.cards?.length || this.renderedScrollLeft === undefined) return;
        const delta = this.viewport.scrollLeft - this.renderedScrollLeft;
        if (Math.abs(delta) < .5) return;
        this.stopScrolling(); this.finiteSelection = null;
        this.scrollState.value += delta; this.scrollTarget = this.scrollState.value;
        this.renderScroll();
      }, { passive: true });
      on(this.viewport, 'pointermove', event => {
        if (this.drag && event.pointerId === this.drag.id) { this.dragMove(event); return; }
      });
      on(this.viewport, 'pointerdown', event => {
        this.lastPointer = event.pointerType;
        const card = event.target.closest('.rr-dock__card');
        this.touchWasInactive = event.pointerType === 'touch' && card && Number(card.dataset.index) !== this.selected;
        if (!this.carousel || event.button > 0 || event.target.closest('button,input,select,textarea')) return;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, start: this.scrollState.value, lastX: event.clientX, lastTime: performance.now(), velocity: 0, active: false };
      });
      on(this.viewport, 'pointerup', event => this.dragEnd(event));
      on(this.viewport, 'pointercancel', event => this.cancelDrag(event));
      on(this.viewport, 'lostpointercapture', event => this.cancelDrag(event));
      on(this.viewport, 'dragstart', event => { if (this.carousel) event.preventDefault(); });
      on(this, 'click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); event.stopPropagation(); return; }
        const sizeButton = event.target.closest('[data-size-select]');
        if (sizeButton && this.contains(sizeButton)) {
          if (!sizeButton.disabled) {
            event.preventDefault(); event.stopPropagation();
            this.setSize(Number(sizeButton.closest('.rr-dock__card').dataset.index), sizeButton.dataset.sizeSelect, true);
          }
          return;
        }
        const link = event.target.closest('[data-product-link]'); if (!link) return;
        const index = Number(link.closest('.rr-dock__card').dataset.index);
        if (event.detail !== 0 && this.dataset.firstTap === 'true' && this.lastPointer === 'touch' && this.touchWasInactive) {
          event.preventDefault(); this.navigate(index); this.touchWasInactive = false;
        }
      }, { capture: true });
      on(this, 'focusin', event => {
        const card = event.target.closest('.rr-dock__card');
        if (card && !this.programmaticFocus && !event.target.closest('[data-size-controls]')) this.navigate(Number(card.dataset.index));
      });
      on(this, 'keydown', event => {
        const card = event.target.closest('.rr-dock__card'); if (!card) return;
        const sizeControls = event.target.closest('[data-size-controls]');
        if (sizeControls) {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'Home' || event.key === 'End') {
            const buttons = Array.from(sizeControls.querySelectorAll('[data-size-select]:not(:disabled)'));
            const current = buttons.indexOf(event.target.closest('[data-size-select]'));
            const index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : mod(current + (event.key === 'ArrowLeft' ? -1 : 1), buttons.length);
            const button = buttons[index];
            if (button) {
              event.preventDefault(); event.stopPropagation();
              this.setSize(Number(card.dataset.index), button.dataset.sizeSelect, true);
              button.focus({ preventScroll: true });
            }
          }
          return;
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.navigateStep(event.key === 'ArrowLeft' ? -1 : 1, true);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); this.navigate(event.key === 'Home' ? 0 : this.originals.length - 1, true);
        }
      });
      on(this.previous, 'click', () => this.navigateStep(-1));
      on(this.next, 'click', () => this.navigateStep(1));
      on(this.motion, 'change', () => { this.stopScrolling(); this.updateWave(true); });
      on(document, 'shopify:block:select', event => {
        const card = event.target.closest('.rr-dock__card');
        if (card && this.contains(card)) this.navigate(Number(card.dataset.index));
      });
      this.layout(this.selected);
      this.resizeObserver = new ResizeObserver(() => {
        if (!this.resizeFrame) this.resizeFrame = requestAnimationFrame(() => {
          this.resizeFrame = 0;
          const phase = this.loop ? mod(this.scrollState.value, this.cycleWidth) / this.stride : this.selected;
          this.layout(phase);
        });
      });
      this.resizeObserver.observe(this.viewport);
      const lifecycle = this.controller;
      if (!this.motion.matches) loadGSAP().then(gsap => {
        if (this.isConnected && this.controller === lifecycle) { this.gsap = gsap; this.updateWave(true); }
      });
    }
    applySize(card, size, eager = false) {
      if (size !== '20' && size !== '100') return false;
      const template = card.querySelector('template[data-size-template="' + size + '"]');
      if (!template) return false;
      const variantId = template.dataset.variantId;
      const variantUrl = template.dataset.variantUrl;
      const available = template.dataset.variantAvailable === 'true';
      card.dataset.selectedSize = size;
      card.dataset.selectedVariantId = variantId;
      card.querySelectorAll('[data-size-select]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sizeSelect === size)));
      const gallery = card.querySelector('[ref="cardGallery"],.card-gallery,.product-card-gallery');
      const nextArt = template.content.querySelector('.rr-native-cutout');
      const currentArt = gallery?.querySelector('.rr-native-cutout');
      if (gallery && nextArt) {
        const replacement = nextArt.cloneNode(true);
        const image = replacement.querySelector('img');
        if (image) {
          if (!image.getAttribute('alt')) image.setAttribute('alt', card.dataset.title + ', ' + size + 'ml');
          if (eager) image.loading = 'eager';
        }
        if (currentArt) {
          replacement.style.transform = currentArt.style.transform;
          this.gsap?.killTweensOf(currentArt);
          currentArt.replaceWith(replacement);
        } else gallery.prepend(replacement);
        gallery.classList.add('rr-custom-gallery');
      }
      card.querySelectorAll('[data-product-link],a.product-card__link').forEach(link => link.setAttribute('href', variantUrl));
      const priceComponent = card.querySelector('product-price');
      const price = priceComponent?.querySelector('[ref="priceContainer"]') || priceComponent || card.querySelector('[data-price-container]');
      const nextPrice = template.content.querySelector('[data-size-price]');
      if (price && nextPrice) price.replaceChildren(nextPrice.cloneNode(true));
      // Keep native quick-add forms and variant links aligned with the chosen size.
      const nativeCard = card.querySelector('product-card');
      nativeCard?.setAttribute('data-selected-variant-id', variantId);
      card.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        const input = form.querySelector('input[name="id"]');
        if (input) { input.value = variantId; input.setAttribute('value', variantId); }
        form.querySelectorAll('button[type="submit"],input[type="submit"]').forEach(button => {
          if (button.getAttribute('aria-busy') !== 'true') button.disabled = !available;
        });
      });
      card.querySelectorAll('quick-add-component[data-product-url]').forEach(component => component.setAttribute('data-product-url', variantUrl));
      return true;
    }
    setSize(index, size, announce = false) {
      const original = this.originals[index];
      const template = original?.querySelector('template[data-size-template="' + size + '"]');
      if (!template || (size !== '20' && size !== '100')) return;
      const matches = (this.cards || this.originals).filter(card => Number(card.dataset.index) === index);
      matches.forEach(card => this.applySize(card, size, announce));
      if (announce) {
        const unavailable = template.dataset.variantAvailable !== 'true' ? ', out of stock' : '';
        this.querySelector('[data-status]').textContent = original.dataset.title + ', ' + size + 'ml' + unavailable;
      }
      this.updateWave(true);
    }
    cloneCard(card) {
      const copy = card.cloneNode(true); const prefix = `rr-loop-${++copySequence}-`;
      copy.dataset.loopCopy = 'true'; copy.setAttribute('aria-hidden', 'true');
      const nodes = [copy, ...copy.querySelectorAll('*')]; const ids = new Map();
      nodes.forEach(node => { if (node.id) { ids.set(node.id, prefix + node.id); node.id = prefix + node.id; } });
      nodes.forEach(node => {
        Array.from(node.attributes).forEach(attribute => { if (attribute.name.startsWith('data-shopify-editor')) node.removeAttribute(attribute.name); });
        ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'list', 'form', 'headers'].forEach(name => {
          const value = node.getAttribute(name);
          if (value) node.setAttribute(name, value.split(/\s+/).map(id => ids.get(id) || id).join(' '));
        });
        const href = node.getAttribute('href'); if (href?.startsWith('#') && ids.has(href.slice(1))) node.setAttribute('href', '#' + ids.get(href.slice(1)));
        if (node.matches('a,button,input,select,textarea,[tabindex]')) node.setAttribute('tabindex', '-1');
      });
      return copy;
    }
    layout(phase) {
      this.stopScrolling();
      cancelAnimationFrame(this.animationFrame);
      this.querySelectorAll('[data-loop-copy]').forEach(copy => { this.gsap?.killTweensOf([copy, this.art(copy)]); copy.remove(); });
      this.cards = this.originals.slice(); this.originalStart = 0;
      this.toggleAttribute('data-loop-ready', this.loop);
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const width = this.originals[0].getBoundingClientRect().width || 184;
      this.stride = width + gap; this.cycleWidth = this.stride * this.originals.length;
      if (this.loop) {
        const cycles = Math.max(1, Math.ceil(this.viewport.clientWidth / this.cycleWidth));
        const before = document.createDocumentFragment(), after = document.createDocumentFragment();
        for (let i = 0; i < cycles; i++) {
          this.originals.forEach(card => before.append(this.cloneCard(card)));
          this.originals.forEach(card => after.append(this.cloneCard(card)));
        }
        this.track.prepend(before); this.track.append(after);
        this.originalStart = cycles * this.originals.length;
        this.cards = Array.from(this.track.querySelectorAll(':scope > .rr-dock__card'));
      }
      const box = this.originals[0].getBoundingClientRect(), view = this.viewport.getBoundingClientRect();
      this.anchor = box.left - view.left + this.viewport.scrollLeft + box.width / 2 - this.viewport.clientWidth / 2;
      this.positions = this.cards.map(() => ({ y: 0, scale: 1 }));
      this.scrollState.value = this.loop ? phase * this.stride : Math.max(0, this.anchor + phase * this.stride);
      this.scrollTarget = this.scrollState.value;
      this.renderScroll(true);
    }
    clampScroll(value) { return this.loop ? value : Math.max(0, Math.min(Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth), value)); }
    renderScroll(immediate = false) {
      this.scrollState.value = this.clampScroll(this.scrollState.value);
      this.viewport.scrollLeft = this.loop ? this.anchor + mod(this.scrollState.value, this.cycleWidth) : this.scrollState.value;
      this.renderedScrollLeft = this.viewport.scrollLeft;
      this.updateWave(immediate);
    }
    scrollTo(value, immediate = false) {
      this.scrollTarget = this.clampScroll(value);
      cancelAnimationFrame(this.scrollFrame);
      if (immediate || this.motion.matches) {
        this.gsap?.killTweensOf(this.scrollState); this.scrollState.value = this.scrollTarget; this.renderScroll(); return;
      }
      if (this.gsap) {
        this.gsap.to(this.scrollState, { value: this.scrollTarget, duration: .38, ease: 'power3.out', overwrite: true, onUpdate: () => this.renderScroll() });
      } else {
        let last = performance.now();
        const tick = time => {
          const delta = this.scrollTarget - this.scrollState.value;
          this.scrollState.value += delta * (1 - Math.exp(-Math.min(64, time - last) / 80)); last = time;
          if (Math.abs(delta) < .1) this.scrollState.value = this.scrollTarget;
          this.renderScroll();
          if (Math.abs(delta) >= .1 && this.isConnected) this.scrollFrame = requestAnimationFrame(tick);
        }; this.scrollFrame = requestAnimationFrame(tick);
      }
    }
    stopScrolling() {
      cancelAnimationFrame(this.scrollFrame); this.gsap?.killTweensOf(this.scrollState);
      if (this.scrollState) this.scrollTarget = this.scrollState.value;
    }
    dragMove(event) {
      const drag = this.drag, dx = event.clientX - drag.x, dy = event.clientY - drag.y;
      if (!drag.active) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
        if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
        this.stopScrolling(); drag.start = this.scrollState.value;
        drag.active = true; this.viewport.setPointerCapture?.(event.pointerId);
      }
      event.preventDefault();
      this.finiteSelection = null;
      const now = performance.now();
      drag.velocity = (drag.lastX - event.clientX) / Math.max(8, now - drag.lastTime);
      drag.lastX = event.clientX; drag.lastTime = now;
      this.scrollTo(drag.start - dx, true);
    }
    cancelDrag(event) {
      if (!this.drag || (event.pointerId !== undefined && this.drag.id !== event.pointerId)) return;
      const active = this.drag.active; this.drag = null;
      if (active) this.suppressClickUntil = performance.now() + 350;
    }
    dragEnd(event) {
      const drag = this.drag; if (!drag || drag.id !== event.pointerId) return;
      this.drag = null;
      if (drag.active) {
        this.suppressClickUntil = performance.now() + 350;
        this.viewport.releasePointerCapture?.(event.pointerId);
        const velocity = performance.now() - drag.lastTime < 100 ? drag.velocity : 0;
        this.scrollTo(this.scrollState.value + Math.max(-this.viewport.clientWidth, Math.min(this.viewport.clientWidth, velocity * 180)));
      }
    }
    selectSource(index, announce = false) {
      this.selected = this.loop ? mod(index, this.originals.length) : Math.min(this.originals.length - 1, Math.max(0, index));
      if (!this.loop) this.finiteSelection = this.selected;
      if (announce) this.querySelector('[data-status]').textContent = this.originals[this.selected].dataset.title;
      const current = this.focusPosition ?? this.originalStart + this.selected;
      const candidates = this.cards.map((card, i) => Number(card.dataset.index) === this.selected ? i : -1).filter(i => i >= 0);
      const nearest = candidates.reduce((best, i) => Math.abs(i - current) < Math.abs(best - current) ? i : best, candidates[0]);
      this.animateWave(nearest);
    }
    navigateStep(step, focus = false) {
      const phase = this.loop ? Math.round(this.scrollTarget / this.stride) : this.selected;
      this.navigate(phase + step, focus, true);
    }
    navigate(index, focus = false, exactPhase = false) {
      this.selected = this.loop ? mod(index, this.originals.length) : Math.min(this.originals.length - 1, Math.max(0, index));
      if (!this.loop) this.finiteSelection = this.selected;
      let target = this.anchor + this.selected * this.stride;
      if (this.loop) {
        const phase = this.scrollTarget / this.stride;
        const nearest = exactPhase ? index : this.selected + Math.round((phase - this.selected) / this.originals.length) * this.originals.length;
        target = nearest * this.stride;
      }
      this.querySelector('[data-status]').textContent = this.originals[this.selected].dataset.title;
      if (focus) { this.programmaticFocus = true; this.originals[this.selected].querySelector('[data-product-link]')?.focus({ preventScroll: true }); this.programmaticFocus = false; }
      this.scrollTo(target);
    }
    updateWave(immediate = false) {
      if (!this.cards?.length) return;
      if (!this.carousel) { this.animateWave(this.selected, immediate); return; }
      if (!this.loop && this.finiteSelection !== null) { this.animateWave(this.finiteSelection, immediate); return; }
      const first = this.cards[0].getBoundingClientRect();
      const view = this.viewport.getBoundingClientRect();
      const focusX = view.left + this.viewport.clientWidth / 2;
      const position = (focusX - first.left - first.width / 2) / this.stride;
      this.animateWave(Math.max(0, Math.min(this.cards.length - 1, position)), immediate);
    }
    animateWave(position, immediate = false) {
      this.focusPosition = position;
      const nearest = Math.round(position);
      this.selected = Number(this.cards[nearest]?.dataset.index || 0);
      if (this.previous) this.previous.disabled = this.originals.length < 2 || (!this.loop && this.selected === 0);
      if (this.next) this.next.disabled = this.originals.length < 2 || (!this.loop && this.selected === this.originals.length - 1);
      this.cards.forEach((card, i) => card.classList.toggle('is-active', this.loop ? Number(card.dataset.index) === this.selected : i === nearest));
      this.targets = this.cards.map((card, i) => {
        const offset = i - position;
        // Repeated cards share a wave state, so wrapping the scroll position is invisible.
        const distance = this.loop ? Math.abs(offset - Math.round(offset / this.originals.length) * this.originals.length) : Math.abs(offset);
        const influence = Math.sin(Math.max(0, 1 - distance / this.radius) * Math.PI / 2) ** 2;
        return this.motion.matches || !this.carousel ? { y: 0, scale: 1 } : { y: -this.lift * influence, scale: 1 + (this.scale - 1) * influence };
      });
      cancelAnimationFrame(this.animationFrame);
      if (this.gsap) {
        this.cards.forEach((card, i) => {
          const art = this.art(card), target = this.targets[i], previous = this.positions[i];
          if (!immediate && Math.abs(previous.y - target.y) < .02 && Math.abs(previous.scale - target.scale) < .001) return;
          this.positions[i] = { ...target };
          if (immediate || this.motion.matches) { this.gsap.killTweensOf([card, art]); this.gsap.set(card, { y: target.y }); this.gsap.set(art, { scale: target.scale }); }
          else { this.gsap.to(card, { y: target.y, duration: .3, ease: 'power3.out', overwrite: true }); this.gsap.to(art, { scale: target.scale, duration: .3, ease: 'power3.out', overwrite: true }); }
        });
      } else if (immediate || this.motion.matches) { this.positions = this.targets.map(target => ({ ...target })); this.draw(); }
      else {
        let last = performance.now();
        const tick = time => {
          const blend = 1 - Math.exp(-Math.min(64, time - last) / 65); last = time; let remaining = 0;
          this.positions.forEach((state, i) => ['y', 'scale'].forEach(key => { const delta = this.targets[i][key] - state[key]; state[key] += delta * blend; remaining += Math.abs(delta); }));
          this.draw(); if (remaining > .02 && this.isConnected) this.animationFrame = requestAnimationFrame(tick);
        }; this.animationFrame = requestAnimationFrame(tick);
      }
    }
    art(card) { return card.querySelector('.rr-dock__art') || card.querySelector('[ref="cardGallery"],.card-gallery,.product-card-gallery') || card; }
    draw() { this.cards.forEach((card, i) => { card.style.transform = `translateY(${this.positions[i].y}px)`; this.art(card).style.transform = `scale(${this.positions[i].scale})`; }); }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.resizeObserver?.disconnect(); this.stopScrolling();
      [this.animationFrame, this.resizeFrame].forEach(cancelAnimationFrame);
      if (this.gsap) this.cards?.forEach(card => this.gsap.killTweensOf([card, this.art(card)]));
      this.querySelectorAll('[data-loop-copy]').forEach(copy => copy.remove());
      this.removeAttribute('data-loop-ready'); this.removeAttribute('data-ready'); this.drag = null; this.resizeFrame = 0;
    }
  }
  customElements.define(tagName, RRBottleDock);
})();

  } catch(e) { console.error(e); }
})();
})();
